import { IBoundedContext } from '../../config';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/Rx';
import 'rxjs/add/observable/throw';
import { ApiService, ConfigService } from '../../shared/services';
import { TransferProduct, TransferDelete } from '../shared/models';

@Injectable()
export class TransferDetailService {

  private _inventory: IBoundedContext;

  constructor(
                private _apiService: ApiService,
                private _configService: ConfigService ) {
                     this._inventory = this._configService.getContext('inventory');
                }

  getTransferProducts(transferId: number): Observable<TransferProduct[]> {
            return this._apiService.get(this._inventory.url, `transfers/${ transferId }/items`)
               .map(response => response.data.map(p => new TransferProduct(p)))
               .cache();
  }

  deleteTransfer(transferDelete: TransferDelete): Observable<boolean> {
            return this._apiService.delete(
                                            this._inventory.url,
                                            'transfers',
                                            transferDelete)
                .map(res => res);
  }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/inventory/transfer-detail/transfer-detail.service.ts